import styled from "styled-components";

const INPUT_BAR_BG = 'rgba(255, 255, 255, 0.1)';

export const InputBarContainer = styled.fieldset`
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    min-inline-size: 0;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    background: ${INPUT_BAR_BG};
    /* Legend position follows the fieldset's text-align, including inherited center. */
    text-align: ${props => props.$align === 'center' ? 'center' : 'left'};
    transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out;

    &:focus-within {
        border-color: ${props => props.$readOnly ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.45)'};
        box-shadow: ${props => props.$readOnly ? 'none' : '0 0 0 1px rgba(255, 255, 255, 0.12)'};
    }
`;

/* Keeps the interactive row at PrimaryBtn height; legend sits on the border above */
export const InputBarControl = styled.div`
    position: relative;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    align-items: center;
    width: 100%;
`;

export const InputBarPrefix = styled.span`
    display: flex;
    align-items: center;
    padding-left: 12px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 500;
    flex-shrink: 0;
    line-height: 1;
`;

export const InputBarComponent = styled.input`
    appearance: none;
    background: transparent;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: #FFFFFF;
    color-scheme: dark;
    display: block;
    flex: 1 1 auto;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 100%;
    line-height: 38px;
    margin: 0;
    min-width: 0;
    cursor: ${props => props.$readOnly ? 'default' : 'text'};
    outline: none;
    padding: ${props => props.$hasPrefix ? '0 12px 0 4px' : '0 12px'};
    text-align: ${props => props.$align === 'center' ? 'center' : 'left'};
    padding-right: ${props => props.$hasPasswordToggle ? '36px' : undefined};
    width: 100%;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    /* Kill global .panel-bg styles from index.css */
    &.panel-bg,
    &.widget-bg {
        align-items: unset;
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
        background: transparent;
        border: none;
        border-radius: 4px;
        box-shadow: none;
        display: block;
        height: 100%;
        padding: ${props => props.$hasPrefix ? '0 12px 0 4px' : '0 12px'};
        padding-right: ${props => props.$hasPasswordToggle ? '36px' : undefined};
        width: 100%;
    }

    &::-webkit-calendar-picker-indicator {
        cursor: pointer;
        filter: invert(1);
        opacity: 0.7;
    }

    /* Prevent browser autofill from changing background */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px ${INPUT_BAR_BG} inset !important;
        -webkit-text-fill-color: #FFFFFF !important;
        background-color: transparent !important;
        transition: background-color 5000s ease-in-out 0s;
    }
`;

/* In-flow legend — creates a real gap in the fieldset border. No float. */
export const InputLabel = styled.legend`
    display: block;
    width: max-content;
    max-width: 100%;
    padding: 0 5px;
    margin-left: ${props => props.$align === 'center' ? 'auto' : '8px'};
    margin-right: ${props => props.$align === 'center' ? 'auto' : '0'};
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.65);
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 11px;
    font-weight: 500;
    background: transparent;
`;

export const InputBarPasswordToggle = styled.button`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    z-index: 1;

    &:hover {
        color: rgba(255, 255, 255, 0.9);
    }
`;
